export default __webpack_public_path__ + "backgroundMusic.wav";